import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const statusMap: Record<string, { label: string; className: string }> = {
  OPEN: { label: 'Novo', className: 'bg-gray-500 text-white' },
  ASSIGNED: { label: 'Atribuído', className: 'bg-teal-500 text-white' },
  IN_PROGRESS: { label: 'Em atendimento', className: 'bg-cyan-500 text-white' },
  DONE: { label: 'Atendido', className: 'bg-blue-500 text-white' },
  CLOSED: { label: 'Encerrado', className: 'bg-primary text-primary-foreground' },
  CANCELED: { label: 'Cancelado', className: 'bg-red-500 text-white' },
}

export default function Component({ status }: { status: string }) {
  const info = statusMap[status]

  return (
    <Badge className={cn('border-transparent font-normal', info?.className)}>
      {info?.label ?? ''}
    </Badge>
  )
}
